import React from 'react';
import '../styles/HomePage.css';

const Content: React.FC = () => {
  return (
    <section className='content'>
      <div className='content-columns'>
        <div className='content-left'>
          <h2 style={{ borderBottom: '1px solid #002855', width: '120%' }}>
            Athena for Partners
          </h2>
          <h3>The Future of Innovation</h3>
          <p>
            Athena is a collaborative research tool built to enable warfighters,
            researchers, engineers, senior leaders, and professionals across the
            DOD, academia, and industry to share expertise and resources across
            organizational boundaries as they rapidly solve problems.
          </p>
          <p>
            The Naval Postgraduate School is a natural nexus and a global hub
            for innovative collaboration across these organizations. As NPS
            transforms physically with the Naval Innovation Center, Athena as
            the virtual element is expanding outward and leveraging a suite of
            collaborative tools to support highly distributed teams and
            partners. Athena enables discovery of completed research, ongoing
            research, and potential topics for future research.
          </p>
        </div>
        <div className='content-right'>
          <div className='strategic-need'>
            <h3>Strategic Need</h3>
            <p>
              Technological innovation is the competitive edge for the United
              States in the rapidly evolving global security landscape. The DOD
              must connect with and engage the top talent across government,
              industry, and academia in order to accelerate the identification
              and adoption of innovative ideas needed to win in an increasingly
              complex security environment.
            </p>
          </div>
        </div>
      </div>
      <blockquote>
        "Athena is an extremely exciting tool that will allow for much-needed
        connection in real-time efforts across the DOD. <br />
        Athena will be a game-changer for the DOD."
        <footer>- Capt. Emily Hastings, USMC, NPS '23</footer>
      </blockquote>
    </section>
  );
};

export default Content;
